import { ApiOperationType, EntityListTypeName } from '@ydistri/api-sdk';
import {
  IProjectSignal,
  ITemplateSignal,
  ProjectConfigurationEntityType,
  SignalrUpdate,
} from '../../../signalr/signalrInterfaces';

/**
 * User entered data can be either added to the existing list or replace the existing list
 */
export enum AdministrationItemListHandlingMethod {
  ADD = 'add',
  REPLACE = 'replace',
}

export enum ModalMode {
  CREATE,
  EDIT,
}

/**
 * Possible actions that can be performed on an item for each of the possible handling methods
 */
export enum AdministrationItemAction {
  /** When the item is already in the list but the user entered it again, it will stay in the list */
  NONE = 'none',
  /** Item is new and will be inserted */
  INSERT = 'insert',
  /** Item is already in the list but new data was entered (a quantity for example) so it will be updated */
  UPDATE = 'update',
  /** Item is in the list but not in the user entered data and the handling method is Replace */
  REMOVE = 'remove',
}

/**
 * Content of the administration item as entered by the user (pasted or typed in) and parsed by the frontend
 */
export interface AdministrationItemRow<T> {
  /** Where in the source content the item was found */
  rowNumber: number;
  /** The content of the item as entered by the user and parsed to specific attributes  */
  inputData: Partial<T>;
  /** True if there is an error in the data (invalid or missing values, duplicates) */
  isError?: boolean;
  /** List of errors in the data (if there are any) */
  errors?: string[];
  /** Specific attribute to indicate that the item is a duplicate of another item in the list. Duplicate item is also an error */
  isDuplicate?: boolean;
}

export type AdministrationItemParserFunction<T> = (content: string, parser?: DOMParser) => T[];

export interface AdministrationItemParser<T> {
  contentType: string;
  parse: AdministrationItemParserFunction<T>;
}

export interface CountableDetail {
  count: number;
  description: string;
}

export enum StatisticsItemType {
  SUCCESS,
  ERROR,
  REMOVED,
  UNCHANGED,
}

export interface StatisticsItem {
  observation: number;
  label: string;
  type: StatisticsItemType;
}

export interface SignalProjectConfigurationChanged extends IProjectSignal, ITemplateSignal {
  entityType: ProjectConfigurationEntityType;
  entityId: number;
  operationType: ApiOperationType;
  /** Wire name from the backend notify DTO (ProjectSlug); the value is currently the project short name. */
  projectSlug: string;
  updates: SignalrUpdate[];
  entityListTypeNames: EntityListTypeName[];
}
